import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoardSnowBl = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 96,
	height: 41,
	fill: "none",
	viewBox: "0 0 96 41",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 28.88,
		cy: 15.15,
		fill: "#fff",
		rx: 28.88,
		ry: 14.7
	}), /* @__PURE__ */ _jsx("ellipse", {
		cx: 55.65,
		cy: 20.66,
		fill: "#fff",
		rx: 39.99,
		ry: 20.11
	})]
});
export default SvgBoardSnowBl;
